(() => {
  const drawer = document.getElementById('drawer');
  const drawerItems = document.getElementById('drawerItems');
  const count = document.getElementById('cartCount');
  const subtotalEl = document.getElementById('cartSubtotal');
  const shippingProgressText = document.querySelector('[data-shipping-message]');
  const shippingNotices = document.querySelectorAll('[data-shipping-notice]');
  const checkoutButton = document.querySelector('.drawer-foot > button');

  const quickBuyBackdrop = document.getElementById('quickBuyBackdrop');
  const quickBuyTitle = document.getElementById('quickBuyTitle');
  const quickBuyPrice = document.getElementById('quickBuyPrice');
  const quickBuyMeta = document.getElementById('quickBuyMeta');
  const quickBuyImage = document.getElementById('quickBuyImage');
  const quickBuyMeasurements = document.getElementById('quickBuyMeasurements');
  const sizeOptions = document.getElementById('sizeOptions');
  const sizeFeedback = document.getElementById('sizeFeedback');
  const quickBuyAdd = document.getElementById('quickBuyAdd');

  if (!drawer || !drawerItems || !quickBuyBackdrop || !sizeOptions || !quickBuyAdd) return;

  let cart = { items: [], item_count: 0, total_price: 0 };
  let activeProduct = null;
  let selectedVariant = null;
  let quickBuyTrigger = null;
  let drawerTrigger = null;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const TD_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
  const TD_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  const TD_US = document.body.dataset.country === 'US';
  const L = (es, en) => (TD_EN ? en : es);
  const TD_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = cents => new Intl.NumberFormat(TD_CURRENCY === 'MXN' ? 'es-MX' : 'en-US', {
    style: 'currency',
    currency: TD_CURRENCY,
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0
  }).format(Number(cents || 0) / 100);

  const escapeHtml = value => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  // V9 · Talla: en celular la ficha abre un panel de tallas; en PC y en compra
  // rápida se iluminan las tallas con un aviso visible.
  const isPhone = () => window.matchMedia('(max-width: 720px)').matches;

  function flashNeedsSize(group) {
    if (!group) return;
    group.classList.remove('td-needs-size');
    void group.offsetWidth;
    group.classList.add('td-needs-size');
    window.clearTimeout(group.tdNeedsSizeTimer);
    group.tdNeedsSizeTimer = window.setTimeout(() => group.classList.remove('td-needs-size'), 1800);
    const rect = group.getBoundingClientRect();
    if (rect.top < 70 || rect.bottom > window.innerHeight) {
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function getProductImage(trigger, productName) {
    const cardImage = trigger.closest('.product-card')?.querySelector('.product-media img');
    if (cardImage) return cardImage.src;

    const matchingCard = [...document.querySelectorAll('.product-card')].find(card =>
      card.querySelector('h3')?.textContent.trim() === productName
    );
    return matchingCard?.querySelector('.product-media img')?.src || '';
  }

  function getProductData(key) {
    const element = document.getElementById(`v46-product-${key}`);
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch {
      return null;
    }
  }

  const optionLabel = value => TD_EN ? ({ 'ÚNICA': 'ONE SIZE', 'AJUSTABLE': 'ADJUSTABLE' }[value] || value) : value;

  function getVariantSize(variant) {
    return optionLabel(variant.option1 || variant.options?.[0] || variant.title);
  }

  function openQuickBuy(trigger) {
    const shopifyProduct = getProductData(trigger.dataset.productKey);
    const fallbackSizes = (trigger.dataset.sizes || 'S,M,L,XL,2XL').split(',');
    const variants = shopifyProduct?.variants || [];

    activeProduct = {
      name: trigger.dataset.product,
      price: trigger.dataset.price,
      priceValue: Number(trigger.dataset.priceValue || 0),
      meta: trigger.dataset.meta || '',
      sizes: variants.length ? variants.map(getVariantSize) : fallbackSizes,
      variants,
      image: getProductImage(trigger, trigger.dataset.product),
      url: trigger.dataset.productUrl || shopifyProduct?.url || (shopifyProduct?.handle ? `/products/${shopifyProduct.handle}` : '')
    };
    selectedVariant = null;
    quickBuyTrigger = trigger;

    quickBuyTitle.textContent = activeProduct.name;
    quickBuyPrice.textContent = activeProduct.price;
    quickBuyMeta.textContent = activeProduct.meta;
    const quickBuyMsi = document.getElementById('quickBuyMsi');
    if (quickBuyMsi) {
      quickBuyMsi.textContent = trigger.dataset.msi || '';
      quickBuyMsi.hidden = TD_US || !trigger.dataset.msi;
    }
    quickBuyImage.src = activeProduct.image;
    quickBuyImage.alt = activeProduct.name;
    if (quickBuyMeasurements) {
      quickBuyMeasurements.href = activeProduct.url ? `${activeProduct.url}#medidas` : '#medidas';
    }
    quickBuyAdd.disabled = false;
    sizeFeedback.textContent = '';
    sizeFeedback.classList.remove('is-error');
    sizeOptions.classList.remove('td-needs-size');

    sizeOptions.innerHTML = activeProduct.sizes.map(size => {
      const variant = activeProduct.variants.find(item => getVariantSize(item) === size);
      const unavailable = variant && !variant.available;
      return `<button class="size-option" type="button" data-size="${escapeHtml(size)}"${unavailable ? ' disabled' : ''}>${escapeHtml(size)}</button>`;
    }).join('');

    const enabledOptions = sizeOptions.querySelectorAll('.size-option:not(:disabled)');
    if (activeProduct.sizes.length === 1 && enabledOptions.length === 1) enabledOptions[0].click();

    quickBuyBackdrop.hidden = false;
    quickBuyBackdrop.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    sizeOptions.querySelector('.size-option:not(:disabled)')?.focus();
  }

  function closeQuickBuy(returnFocus = true) {
    quickBuyBackdrop.hidden = true;
    quickBuyBackdrop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activeProduct = null;
    selectedVariant = null;
    if (returnFocus) quickBuyTrigger?.focus();
    quickBuyTrigger = null;
  }

  function openDrawer(trigger) {
    refreshCart().catch(() => {});
    drawerTrigger = trigger || document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.getElementById('closeCart')?.focus();
  }

  function closeDrawer(returnFocus = true) {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (returnFocus && drawerTrigger instanceof HTMLElement) drawerTrigger.focus();
    drawerTrigger = null;
  }

  function keepFocusInside(event, container) {
    if (event.key !== 'Tab') return;
    const focusable = [...container.querySelectorAll(focusableSelector)]
      .filter(element => !element.hasAttribute('hidden') && element.getAttribute('aria-hidden') !== 'true');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  async function requestCart(path, options) {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...options
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || L('No fue posible actualizar el carrito.', 'Could not update cart.'));
    return data;
  }

  async function refreshCart() {
    cart = await requestCart('cart.js');
    renderCart();
  }

  async function addToCart(variantId) {
    await requestCart('cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    await refreshCart();
  }

  async function changeCart(line, quantity) {
    cart = await requestCart('cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ line, quantity })
    });
    renderCart();
  }

  function renderCart() {
    const totalUnits = cart.item_count || 0;
    const subtotal = cart.total_price || 0;

    count.textContent = totalUnits;
    subtotalEl.textContent = money(subtotal);

    shippingNotices.forEach(notice => {
      notice.hidden = totalUnits === 0;
      const threshold = Number(notice.dataset.shippingThreshold);
      const remaining = Math.max(0, threshold - subtotal);
      const progress = Math.min(100, Math.round(subtotal / threshold * 100));
      const bar = notice.querySelector('[data-shipping-bar]');
      const value = notice.querySelector('[data-shipping-value]');
      const isHeavyUS = TD_US && (Number(cart.total_weight || 0) > 3000);
      if (TD_US) {
        if (bar) bar.parentElement.hidden = isHeavyUS;
        if (value) value.hidden = isHeavyUS;
      }
      if (bar) bar.style.width = `${isHeavyUS ? 0 : progress}%`;
      if (value) value.textContent = isHeavyUS ? '—' : `${progress}%`;
      if (isHeavyUS) {
        notice.querySelector('[data-shipping-message]').textContent = L('ENVÍO ESTÁNDAR SEGÚN PESO · PAQUETE MAYOR A 3 KG', 'STANDARD SHIPPING CHARGED BY WEIGHT · PACKAGE OVER 3 KG');
      } else if (TD_US) {
        const shippingAmount = new Intl.NumberFormat(TD_EN ? 'en-US' : 'es-US', { style: 'currency', currency: 'USD', minimumFractionDigits: remaining % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(remaining / 100);
        notice.querySelector('[data-shipping-message]').textContent = remaining > 0
          ? L(`TE FALTAN ${shippingAmount} PARA ENVÍO ESTÁNDAR GRATIS`, `ADD ${shippingAmount} MORE FOR FREE STANDARD SHIPPING`)
          : L('ENVÍO ESTÁNDAR GRATIS ACTIVADO', 'FREE STANDARD SHIPPING UNLOCKED');
      } else {
        notice.querySelector('[data-shipping-message]').textContent = remaining > 0
          ? `TE FALTAN ${money(remaining)} PARA ENVÍO ESTÁNDAR GRATIS`
          : 'ENVÍO ESTÁNDAR GRATIS ACTIVADO';
      }
      notice.querySelector('[data-shipping-link]').hidden = isHeavyUS || remaining === 0;
    });

    // V10 · Meses sin intereses según el total del carrito.
    const msiNote = document.querySelector('[data-msi-note]');
    if (msiNote) {
      let plans = [];
      try { plans = JSON.parse(msiNote.dataset.msiPlans || '[]'); } catch { plans = []; }
      const plan = plans.find(([, minimum]) => subtotal >= minimum);
      msiNote.hidden = TD_US || !plan || totalUnits === 0;
      if (plan) msiNote.textContent = `PAGA HASTA EN ${plan[0]} MESES SIN INTERESES EN EL CHECKOUT.`;
    }

    if (!cart.items?.length) {
      drawerItems.innerHTML = L('<p>Tu carrito está vacío.</p>', '<p>Your cart is empty.</p>');
      return;
    }

    drawerItems.innerHTML = cart.items.map((item, index) => `
      <div class="drawer-item">
        <img src="${escapeHtml(item.featured_image?.url || item.image || '')}" alt="${escapeHtml(item.product_title)}">
        <div class="drawer-item-copy">
          <b>${escapeHtml(item.product_title)}</b>
          <span class="drawer-item-meta mono">${L('TALLA', 'SIZE')} ${escapeHtml(optionLabel(item.variant_title || ''))} · ${escapeHtml(money(item.final_price))}</span>
          <div class="drawer-item-actions">
            <div class="qty-control">
              <button type="button" data-cart-action="minus" data-line="${index + 1}" data-quantity="${item.quantity}" aria-label="${L('Restar', 'Decrease quantity')}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-action="plus" data-line="${index + 1}" data-quantity="${item.quantity}" aria-label="${L('Sumar', 'Increase quantity')}">+</button>
            </div>
            <button class="remove-item mono" type="button" data-cart-action="remove" data-line="${index + 1}">
              ${L('ELIMINAR', 'REMOVE')}
            </button>
          </div>
        </div>
      </div>
    `).join('');
  }

  document.querySelectorAll('.quick-buy-trigger').forEach(trigger => {
    trigger.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      openQuickBuy(trigger);
    });
  });

  const sizeSheet = document.querySelector('[data-td-size-sheet]');
  const sizeSheetFeedback = sizeSheet?.querySelector('[data-td-sheet-feedback]');
  let sizeSheetForm = null;
  let sizeSheetTrigger = null;

  function resetSizeSheetOptions() {
    sizeSheet?.querySelectorAll('[data-td-sheet-variant]').forEach(option => {
      option.disabled = option.dataset.unavailable === 'true';
      option.classList.remove('selected');
    });
  }

  function openSizeSheet(form, trigger) {
    if (!sizeSheet) return false;
    sizeSheetForm = form;
    sizeSheetTrigger = trigger;
    resetSizeSheetOptions();
    if (sizeSheetFeedback) sizeSheetFeedback.textContent = '';
    sizeSheet.hidden = false;
    sizeSheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    sizeSheet.querySelector('.td-size-sheet__panel')?.focus({ preventScroll: true });
    return true;
  }

  function closeSizeSheet(returnFocus = true) {
    if (!sizeSheet || sizeSheet.hidden) return;
    sizeSheet.hidden = true;
    sizeSheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (returnFocus) sizeSheetTrigger?.focus({ preventScroll: true });
    sizeSheetForm = null;
    sizeSheetTrigger = null;
  }

  document.querySelectorAll('[data-v46-product-form]').forEach(form => {
    const variantInput = form.querySelector('[data-v46-variant-id]');
    const submit = form.querySelector('[data-v46-submit]');
    const feedback = form.querySelector('[data-v46-product-feedback]');
    const variantGrid = form.querySelector('.v46-variant-grid');

    form.querySelectorAll('[data-v46-variant]').forEach(option => {
      option.addEventListener('change', () => {
        variantInput.value = option.value;
        submit.disabled = false;
        feedback.classList.remove('is-error');
        variantGrid?.classList.remove('td-needs-size');
        feedback.textContent = L(`${option.closest('label')?.innerText.trim() || 'OPCIÓN'} SELECCIONADA.`, `${option.closest('label')?.innerText.trim() || 'OPTION'} SELECTED.`);
      });
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!variantInput.value) {
        if (isPhone() && openSizeSheet(form, submit)) return;
        feedback.classList.add('is-error');
        feedback.textContent = L('ELIGE TU TALLA.', 'SELECT YOUR SIZE.');
        flashNeedsSize(variantGrid);
        return;
      }
      submit.disabled = true;
      feedback.classList.remove('is-error');
      feedback.textContent = L('AGREGANDO AL CARRITO…', 'ADDING TO CART…');
      try {
        await addToCart(variantInput.value);
        submit.disabled = false;
        feedback.textContent = L('AGREGADO AL CARRITO.', 'ADDED TO CART.');
        openDrawer(form);
      } catch (error) {
        submit.disabled = false;
        feedback.classList.add('is-error');
        feedback.textContent = String(error.message || error).toUpperCase();
      }
    });
  });

  sizeSheet?.addEventListener('click', async event => {
    if (event.target.closest('[data-td-size-sheet-close]')) {
      closeSizeSheet();
      return;
    }
    if (event.target.closest('[data-td-size-sheet-measure]')) {
      closeSizeSheet(false);
      return;
    }
    const option = event.target.closest('[data-td-sheet-variant]');
    if (!option || option.disabled || !sizeSheetForm) return;

    const form = sizeSheetForm;
    const variantId = option.dataset.tdSheetVariant;
    const radio = [...form.querySelectorAll('[data-v46-variant]')].find(input => input.value === variantId);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      form.querySelector('[data-v46-variant-id]').value = variantId;
    }

    sizeSheet.querySelectorAll('[data-td-sheet-variant]').forEach(button => { button.disabled = true; });
    option.classList.add('selected');
    if (sizeSheetFeedback) sizeSheetFeedback.textContent = L('AGREGANDO AL CARRITO…', 'ADDING TO CART…');
    const feedback = form.querySelector('[data-v46-product-feedback]');

    try {
      await addToCart(variantId);
      if (feedback) feedback.textContent = L('AGREGADO AL CARRITO.', 'ADDED TO CART.');
      closeSizeSheet(false);
      openDrawer(form.querySelector('[data-v46-submit]'));
    } catch (error) {
      resetSizeSheetOptions();
      if (sizeSheetFeedback) sizeSheetFeedback.textContent = String(error.message || error).toUpperCase();
    }
  });

  sizeOptions.addEventListener('click', event => {
    const button = event.target.closest('.size-option');
    if (!button || button.disabled) return;

    const size = button.dataset.size;
    selectedVariant = activeProduct?.variants.find(variant => getVariantSize(variant) === size) || null;
    sizeOptions.querySelectorAll('.size-option').forEach(option => {
      option.classList.toggle('selected', option === button);
    });

    sizeOptions.classList.remove('td-needs-size');
    sizeFeedback.classList.toggle('is-error', !selectedVariant);
    sizeFeedback.textContent = selectedVariant
      ? L(`TALLA ${size} SELECCIONADA.`, `SIZE ${size} SELECTED.`)
      : L('ESTA PIEZA AÚN NO ESTÁ DISPONIBLE EN LA TIENDA ONLINE.', 'THIS PIECE IS NOT YET AVAILABLE ONLINE.');
  });

  quickBuyAdd.addEventListener('click', async () => {
    if (!activeProduct) return;
    if (!selectedVariant) {
      sizeFeedback.classList.add('is-error');
      sizeFeedback.textContent = L('ELIGE TU TALLA.', 'SELECT YOUR SIZE.');
      flashNeedsSize(sizeOptions);
      return;
    }
    quickBuyAdd.disabled = true;
    sizeFeedback.textContent = L('AGREGANDO AL CARRITO…', 'ADDING TO CART…');
    try {
      await addToCart(selectedVariant.id);
      closeQuickBuy(false);
      openDrawer(quickBuyAdd);
    } catch (error) {
      quickBuyAdd.disabled = false;
      sizeFeedback.classList.add('is-error');
      sizeFeedback.textContent = String(error.message || error).toUpperCase();
    }
  });

  drawerItems.addEventListener('click', async event => {
    const control = event.target.closest('[data-cart-action]');
    if (!control) return;

    const line = Number(control.dataset.line);
    const quantity = Number(control.dataset.quantity || 0);
    const action = control.dataset.cartAction;
    control.disabled = true;

    try {
      if (action === 'plus') await changeCart(line, quantity + 1);
      if (action === 'minus') await changeCart(line, Math.max(0, quantity - 1));
      if (action === 'remove') await changeCart(line, 0);
    } catch (error) {
      shippingProgressText.textContent = String(error.message || error).toUpperCase();
      control.disabled = false;
    }
  });

  document.getElementById('openCart')?.addEventListener('click', event => openDrawer(event.currentTarget));
  document.getElementById('closeCart')?.addEventListener('click', () => closeDrawer());
  document.getElementById('closeQuickBuy')?.addEventListener('click', closeQuickBuy);
  checkoutButton?.addEventListener('click', () => { window.location.href = TD_ROOT + 'checkout'; });

  quickBuyBackdrop.addEventListener('click', event => {
    if (event.target === quickBuyBackdrop) closeQuickBuy();
  });

  document.addEventListener('keydown', event => {
    if (!quickBuyBackdrop.hidden) keepFocusInside(event, quickBuyBackdrop);
    if (drawer.classList.contains('open')) keepFocusInside(event, drawer);
    if (sizeSheet && !sizeSheet.hidden) keepFocusInside(event, sizeSheet);
    if (event.key === 'Escape') {
      closeSizeSheet();
      closeQuickBuy();
      closeDrawer();
    }
  });

  document.querySelector('.v46-cart-form')?.addEventListener('change', event => {
    if (event.target.matches('input[name="updates[]"]')) {
      const form = event.currentTarget;
      if (form.reportValidity()) form.requestSubmit(form.querySelector('button[name="update"]'));
    }
  });
  ['cart:updated', 'cart:refresh'].forEach(name => document.addEventListener(name, () => refreshCart().catch(() => {})));
  window.addEventListener('focus', () => refreshCart().catch(() => {}));
  refreshCart().catch(() => {});
})();

(() => {
  const main = document.getElementById('MainContent') || document.querySelector('main');
  if (!main) return;

  const pageText = main.textContent || '';
  const TD_EN2 = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  const ROOT2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const path = window.location.pathname.toLowerCase();
  const isSubscriptionConfirmationPath = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/account\/subscribe\/?$/.test(path);
  const isSubscriptionSystemPage =
    isSubscriptionConfirmationPath ||
    /\/(?:email_subscriptions|customer_subscriptions)\//.test(path) ||
    /\/account\/email\//.test(path) ||
    /lista de distribuci[oó]n|preferencias de correo|subscription preferences|suscripci[oó]n confirmada/i.test(pageText);

  if (!isSubscriptionSystemPage) return;

  document.getElementById('td-subscribe-popup')?.remove();
  document.querySelector('.td-subscribe-popup-section')?.remove();

  const isConfirmed =
    isSubscriptionConfirmationPath ||
    /confirm/.test(path) ||
    /suscripci[oó]n confirmada|subscription confirmed|correo (?:qued[oó]|est[aá]) confirmado/i.test(pageText);

  if (!isConfirmed) return;

  document.body.classList.add('td-subscription-confirmed');

  try {
    const key = 'td_popup_state_v1';
    const state = JSON.parse(window.localStorage.getItem(key) || '{}');
    state.subscribed = true;
    state.subscribedAt = Date.now();
    delete state.pendingAt;
    window.localStorage.setItem(key, JSON.stringify(state));
  } catch {
    // Storage is optional; the popup was already removed for this page.
  }

  main.innerHTML = TD_EN2 ? `
    <section class="td-subscription-confirmation" aria-labelledby="td-subscription-title">
      <div class="td-subscription-confirmation__panel">
        <h1 id="td-subscription-title">SUBSCRIPTION CONFIRMED.</h1>
        <div class="td-subscription-confirmation__copy">
          <p>YOU'RE ON THE LIST.</p>
          <p>Check your inbox for your welcome email and first-order 15% code.</p>
        </div>
        <a class="td-subscription-confirmation__cta" href="${ROOT2}collections/drop-001">EXPLORE DROP 001 →</a>
      </div>
    </section>` : `
    <section class="td-subscription-confirmation" aria-labelledby="td-subscription-title">
      <div class="td-subscription-confirmation__panel">
        <h1 id="td-subscription-title">SUSCRIPCIÓN CONFIRMADA.</h1>
        <div class="td-subscription-confirmation__copy">
          <p>Ya estás en LA LISTA.</p>
          <p>Te enviamos un correo de bienvenida con tu 15% para la primera compra.</p>
        </div>
        <a class="td-subscription-confirmation__cta" href="${ROOT2}collections/drop-001">VER DROP 001 →</a>
      </div>
    </section>`;
  document.title = TD_EN2 ? 'SUBSCRIPTION CONFIRMED. — TERCER DÍA' : 'SUSCRIPCIÓN CONFIRMADA. — TERCER DÍA';
})();


